













import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class File extends Vue {
  @Prop() fileName?: string
  @Prop() loaded = 0
}
